import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Select } from 'components/fields'
import { Button } from 'components/misc'
import { apiLeaders, apiOrganizations, apiCommon } from 'helpers/decorators/api'
import { form } from 'helpers/decorators'
import { modal } from 'redux/modules/app'
import { leadersDropdownSelector } from 'redux/selectors/leaders'
import { organizationsCodeListDropdownSelector } from 'redux/selectors/organizations'
import { transferParticipants } from 'models/leaders'
import { Title, Span } from 'components/layout'
import { getActiveRole } from 'utils/token'
import { ROLES } from 'constants/enums'

@apiCommon()
@apiOrganizations({
  organizationFilter: ''
})
@apiLeaders({
  filter: 'awardUnitLeaders',
  disableQueryFilter: true,
  onlyActive: true
})
@connect(
  state => ({
    dropdownLeaders: leadersDropdownSelector(state),
    dropdownAwardUnits: organizationsCodeListDropdownSelector(state),
    activeOrganization: state.auth.organization
  }),
  {
    modal
  }
)
@form({
  form: 'form-leader-transfer-participants',
  validate: transferParticipants
})
class LeaderParticipantsTransfer extends Component {
  static propTypes = {
    dropdownLeaders: PropTypes.array.isRequired,
    dropdownAwardUnits: PropTypes.array.isRequired,
    modal: PropTypes.func.isRequired,
    fetchCountriesWithStructure: PropTypes.func.isRequired,
    getOrganizationCodeList: PropTypes.func.isRequired,
    getLeaders: PropTypes.func.isRequired,
    leaders: PropTypes.object.isRequired,
    organizations: PropTypes.object.isRequired,
    common: PropTypes.object.isRequired,
    activeOrganization: PropTypes.object.isRequired,
    values: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
    transferLeaderParticipants: PropTypes.func.isRequired
  }

  static defaultProps = {
    values: {}
  }

  componentDidMount = () => {
    if (this.isSuperUser) {
      this.props.fetchCountriesWithStructure()
      return
    }

    this.props.getOrganizationCodeList({
      filterCase: 'awardUnitsOrIacs'
    })
  }

  isSuperUser = getActiveRole(this.props.activeOrganization) ===
    ROLES.IF_STAFF_SUPER.u ||
    getActiveRole(this.props.activeOrganization) === ROLES.GBT.u ||
    getActiveRole(this.props.activeOrganization) === ROLES.OA.u ||
    getActiveRole(this.props.activeOrganization) === ROLES.SOA.u ||
    getActiveRole(this.props.activeOrganization) === ROLES.IF_REGION.u

  handleFetchAwardUnits = (obj = {}) =>
    this.props.getOrganizationCodeList({
      filterById: obj.value,
      filterCase: 'countryAwardUnitsOrIacs'
    })

  handleFetchAwardLeaders = (obj = {}) => this.props.getLeaders(obj.value)

  render() {
    const {
      dropdownLeaders,
      handleSubmit,
      leaders,
      values,
      dropdownAwardUnits,
      organizations,
      common
    } = this.props
    const filterCurrentAwardLevelOut = dropdownLeaders.filter(
      item => item.value !== leaders.detail.id
    )

    let countriesList = common.countries.list

    switch (getActiveRole(this.props.activeOrganization)) {
      case ROLES.GBT.u:
        countriesList = common.ics.list
        break
      // case ROLES.IF_REGION.u:
      //   countriesList = commonRegion(
      //     common.countries.listWithStructure,
      //     activeOrganization.id
      //   )
      //   break
      default:
        break
    }

    return (
      <div>
        <form
          onSubmit={handleSubmit(fields =>
            this.props.transferLeaderParticipants(fields, leaders.detail.id)
          )}
        >
          <Title h2 className="text--center" intlKey="moduleTitle.are_you_sure">
            Transfer participants
          </Title>
          <div className="base-margin--bottom">
            <Span intlKey="text.all_participants_will_be_transfered">
              All participants will be transfered to a new Award Leader
            </Span>
          </div>
          {this.isSuperUser &&
            <div className="row">
              <div className="col-xs-12">
                <Select
                  label="Country"
                  name="countryId"
                  intlKey="label.country"
                  onSelectChange={this.handleFetchAwardUnits}
                  options={countriesList}
                  loading={common.loading}
                  searchable
                />
              </div>
            </div>}
          <div className="row">
            <div className="col-xs-12">
              <Select
                label="Award Unit"
                name="awardUnitId"
                intlKey="label.award_unit"
                onSelectChange={this.handleFetchAwardLeaders}
                options={dropdownAwardUnits}
                loading={organizations.loading}
                disabled={this.isSuperUser && !values.countryId}
                searchable
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <Select
                label="Leaders"
                name="leaderId"
                intlKey="label.leaders"
                disabled={!values.awardUnitId}
                options={filterCurrentAwardLevelOut}
                loading={leaders.loading}
                searchable
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-6">
              <Button
                secondary
                intlKey="button.close"
                type="button"
                onClick={() => this.props.modal(null)}
              >
                Close
              </Button>
            </div>
            <div className="col-xs-6 text--right">
              <Button intlKey="button.change" isLoading={leaders.loading}>
                Change
              </Button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

export default LeaderParticipantsTransfer
